import { Component, Input, ViewEncapsulation, HostListener, ElementRef, OnInit, ViewChild } from '@angular/core';
import { RefinementsService } from '@app/shared/components/catalog/services/refinements.service';
import { CustomSortBySelectorComponent } from '@app/shared/components/catalog/custom-widgets/custom-sort-by-selector/custom-sort-by-selector.component';
import { IndexSortBy } from '@app/shared/components/catalog/custom-widgets/custom-sort-by-selector/index-sort-by';
@Component({
  selector: 'vc-catalog-sort',
  templateUrl: './catalog-sort.component.html',
  styleUrls: ['./catalog-sort.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CatalogSortComponent implements OnInit {
  @ViewChild(CustomSortBySelectorComponent, { static: false })
  customSort: CustomSortBySelectorComponent;

  @Input()
  isMobile: boolean;
  @Input()
  sortListOpen: boolean;

  public selectedSort: number;
  indexSortBy = IndexSortBy;

  constructor(private eRef: ElementRef, private refinementsService: RefinementsService) {}

  public ngOnInit() {
    this.refinementsService.getSortByValue().subscribe(
      ({ index }) => (this.selectedSort = index),
      error => null
    );
  }

  toggleSortList() {
    this.sortListOpen = !this.sortListOpen;
  }

  updateSelectedSort(event) {
    this.selectedSort = event;
    if (!this.isMobile) {
      this.closeSortList();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (
      !this.eRef.nativeElement.contains(event.target) &&
      !event.target.classList.contains('catalog__actionBar__button')
    ) {
      this.closeSortList();
    }
  }

  closeSortList() {
    this.sortListOpen = false;
  }

  resetSelected(): void {
    this.customSort.resetSelected();
  }
}
